<template>
  <v-dialog width="500" v-model="showDaCompanychangeDialog">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> Update Customer on DA </span>

        <v-spacer></v-spacer>
        <v-btn icon @click="showDaCompanychangeDialog = false">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-2">
        <v-form v-if="showDaCompanychangeDialog" v-model="isValid">
          <v-row class="ma-0">
            <v-alert type="info" dense class="mb-2">
              This will also update the DA and leg rates.
            </v-alert>
            <v-col cols="12" class="Form-Columns">
              <Autocomplete
                hide-details="auto"
                label="Select Customer Company"
                :items="allCustomerList"
                itemText="company_title"
                :rules="[(val) => !!val || 'Customer is Required!']"
                itemValue="id"
                :loading="listLoading"
                :totalItems="customerCount"
                @updateList="getCustomerList"
                v-model="formDetails.company"
                @input="onCustomerChange"
              />
            </v-col>
            <v-col cols="12" v-if="previewLoading">
              <v-progress-linear indeterminate color="primary" />
            </v-col>
            <v-col cols="12" v-else-if="previewError">
              <v-alert type="error" dense class="mb-0">{{ previewError }}</v-alert>
            </v-col>
            <v-col cols="12" v-else-if="ratePreview">
              <v-alert type="warning" dense class="mb-0">
                Rate: <strong>{{ ratePreview.current_rate }} → {{ ratePreview.rate }}</strong>
                ({{ ratePreview.contract_id }})
              </v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid || !ratePreview || previewLoading"
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Autocomplete from "@/components/FormBaseComponents/Autocomplete.vue";

export default {
  components: {
    Autocomplete,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
   
   company: {
    type: [Number, String],
    default: null
  },
  id:{
    type: [Number, String],
      default: null
  }


    
  },
  computed: {
    showDaCompanychangeDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      allCustomerList: [],
      customerCount: 0,
      listLoading: false,
      isValid: true,
      formErrors: {},
      formDetails: {},
      ratePreview: null,
      previewError: "",
      previewLoading: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.formDetails = {
          company: this.company,
          id: this.id,
        };
        this.ratePreview = null;
        this.previewError = "";
        this.getCustomerList();
      } else {
        this.allCustomerList = [];
        this.customerCount = 0;
        this.ratePreview = null;
        this.previewError = "";
      }
    },
  },
  methods: {
    onCustomerChange(value) {
      this.ratePreview = null;
      this.previewError = "";
      const customerId = value && typeof value === "object" ? value.id : value;
      if (!customerId) return;

      this.previewLoading = true;
      this.$api.deliveryAdvice
        .previewCustomerRate(this.formDetails.id, customerId)
        .then((res) => {
          this.ratePreview = res.data || res;
        })
        .catch((err) => {
          this.previewError = err?.data?.error || "Could not resolve a rate for this customer.";
        })
        .finally(() => {
          this.previewLoading = false;
        });
    },

    getCustomerList(params = {}) {
      this.listLoading = true;
      params = {
        company_type: "Customer",
        is_active: true,
        limit: 10,
        offset: 0,
        ...params,
      };
      this.$api.company
        .getCompanySelectList(params)
        .then((res) => {
          this.listLoading = false;
          if ("count" in res) {
            this.customerCount = res.count;
          }
          if (params.offset == 0) {
            this.allCustomerList = res.data;
            // Ensure current company is in the list for pre-selection
            if (
              this.company &&
              !res.data.find((c) => c.id == this.company)
            ) {
              this.$api.company
                .getCompanySelectList({ id: this.company, company_type: "Customer" })
                .then((r) => {
                  if (r.data && r.data.length) {
                    this.allCustomerList = [r.data[0], ...this.allCustomerList];
                  }
                });
            }
          } else {
            this.allCustomerList.push(...res.data);
          }
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    
    submitForm() {
      this.$bus.$emit("showLoader", true);
      let payload = {
        company: this.formDetails.company && typeof this.formDetails.company === "object"
          ? this.formDetails.company.id
          : this.formDetails.company,
        id: this.formDetails.id,
      };
     
      this.$api.deliveryAdvice
        .updateDACompany(payload)
        .then(() => {
          this.showDaCompanychangeDialog = false;
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Customer and rate updated successfully!",
            color: "success",
          });
          this.formErrors = {};
          this.$emit("refreshList");
        })
        .catch((err) => {
          this.formErrors = {};
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: err?.data?.error || "Couldn't update customer!",
            color: "error",
          });
        });
    },
  },
};
</script>
